import * as actionTypes from "./actionTypes"
import store from "../store"

export function getCompleteFormStore() {
  return store.getState()
}

export function updateHeaderWarningList(field, value, level) {
  return {
    type: actionTypes.UPDATE_HEADER_WARNINGS,
    field,
    value,
    level,
  }
}

export function removeHeaderWarningList(field, value, level) {
  return {
    type: actionTypes.REMOVE_HEADER_WARNINGS,
    field,
    value,
    level,
  }
}

export function updatePartiesWarningList(field, value, level) {
  return {
    type: actionTypes.UPDATE_PARTIES_WARNINGS,
    field,
    value,
    level,
  }
}

export function removePartiesWarningList(field, value, level) {
  return {
    type: actionTypes.REMOVE_PARTIES_WARNINGS,
    field,
    value,
    level,
  }
}

export function updateInvoiceWarningList(field, value, level, invoiceId) {
  return {
    type: actionTypes.UPDATE_INVOICE_WARNINGS,
    field,
    value,
    level,
    invoiceId,
  }
}

export function removeInvoiceWarningList(field, value, level, invoiceId) {
  return {
    type: actionTypes.REMOVE_INVOICE_WARNINGS,
    field,
    value,
    level,
    invoiceId,
  }
}

export function updateLineWarningList(
  field,
  value,
  level,
  invoiceId,
  merchandiseId,
) {
  return {
    type: actionTypes.UPDATE_LINE_WARNINGS,
    field,
    value,
    level,
    invoiceId,
    merchandiseId,
  }
}

export function removeLineWarningList(
  field,
  value,
  level,
  invoiceId,
  merchandiseId
) {
  return {
    type: actionTypes.REMOVE_LINE_WARNINGS,
    field,
    value,
    level,
    invoiceId,
    merchandiseId,
  }
}
export function removeLineWarningOnDeletionOfInvoice(invoiceId) {
  return {
    type: actionTypes.REMOVE_WARNING_ON_DELETEION_INVOICE,
    invoiceId,
  }
}
export function removeLineWarningOnDeletionOfMerchandiseLine(merchandiseId) {
  return {
    type: actionTypes.REMOVE_WARNING_ON_DELETEION_MERCH,
    merchandiseId,
  }
}
